 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0004 from '@/components/content/content0004'
 import CONTENTCONTENT0005 from '@/components/content/content0005'
 import CONTENTCONTENT0006 from '@/components/content/content0006'
 import CONTENTCONTENT0008 from '@/components/content/content0008'
 import CONTENTCONTENT0014 from '@/components/content/content0014'
 import CONTENTCONTENT0018 from '@/components/content/content0018'
 import CONTENTCONTENT0021 from '@/components/content/content0021'
 import CONTENTCONTENT0026 from '@/components/content/content0026'
 import CONTENTCONTENT0033 from '@/components/content/content0033'
 import CONTENTCONTENT0039 from '@/components/content/content0039'
 import CONTENTCONTENT0045 from '@/components/content/content0045'
 import CONTENTCONTENT0048 from '@/components/content/content0048'
 import CONTENTCONTENT0052 from '@/components/content/content0052'
 import CONTENTCONTENT0056 from '@/components/content/content0056'
 import CONTENTCONTENT0065 from '@/components/content/content0065'
 import CONTENTCONTENT0069 from '@/components/content/content0069'
 import CONTENTCONTENT0081 from '@/components/content/content0081'
 import CONTENTCONTENT0089 from '@/components/content/content0089'
 import CONTENTCONTENT0095 from '@/components/content/content0095'
 import CONTENTCONTENT0100 from '@/components/content/content0100'
 import CONTENTCONTENT0105 from '@/components/content/content0105'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0004",
 			"name" : "content/content0004",
 			"component" : CONTENTCONTENT0004
 		},
 		{
 			"path" : "/content/content0005",
 			"name" : "content/content0005",
 			"component" : CONTENTCONTENT0005
 		},
 		{
 			"path" : "/content/content0006",
 			"name" : "content/content0006",
 			"component" : CONTENTCONTENT0006
 		},
 		{
 			"path" : "/content/content0008",
 			"name" : "content/content0008",
 			"component" : CONTENTCONTENT0008
 		},
 		{
 			"path" : "/content/content0014",
 			"name" : "content/content0014",
 			"component" : CONTENTCONTENT0014
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js